<script lang="ts">
	import { browser } from '$app/environment';

	export let Title = 'Error';
	export let DefaultTitle = 'Error';
	export let Msg = 'Modal.Msg';
	export let shown = false;
	export let ShowConfirm = true;
	export let onClose: () => void = () => {};

	// Generate random GUID for ID
	export const id: string =
		Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

	let refStr = '';
	let showTitle = true;

	// Control modal visibility and body class
	$: {
		if (shown) {
			if (browser) {
				document.body.classList.add('modal-open');
			}
		} else {
			if (browser) {
				document.body.classList.remove('modal-open');
			}
		}
	}

	// Compute modal classes and styles based on 'shown' state
	$: modalClass = `modal fade ${shown ? 'show' : ''}`;
	$: modalStyle = shown ? 'display: block;' : 'display: none;';

	export function Hide() {
		if (onClose) {
			onClose();
		}
		Title = DefaultTitle;
		refStr = '';
		shown = false;
	}

	export function SetTmpTitle(title: string) {
		Title = title;
	}

	export function SetRefStr(str: string) {
		refStr = str;
	}

	export async function Show(msg: string, titleVisible: boolean = true): Promise<void> {
		showTitle = titleVisible;
		if (msg) {
			Msg = msg;
		}
		shown = true;
		//await until hidden
		await new Promise((resolve) => {
			const interval = setInterval(() => {
				if (!shown) {
					clearInterval(interval);
					resolve(void 0);
				}
			}, 100);
		});
	}
</script>

<!-- Modal Backdrop -->
{#if shown}
	<div class="modal-backdrop fade show" />
{/if}

<!-- Modal -->
<div
	class={modalClass}
	{id}
	tabindex="-1"
	aria-labelledby="errorModalLabel"
	aria-hidden={!shown}
	role="dialog"
	style={modalStyle}
>
	<div class="modal-dialog">
		<div class="modal-content">
			{#if showTitle}
				<div class="modal-header">
					<h5 class="modal-title" id="errorModalLabel">{Title}</h5>
					<button class="btn-close" type="button" aria-label="Close" on:click={Hide} />
				</div>
			{/if}
			<div class="modal-body" class:modal-body-centered={!showTitle}>
				<p id="modal_errorMsg">{@html Msg}</p>
			</div>
			{#if refStr || ShowConfirm}
				<div class="modal-footer d-flex justify-content-between">
					<div class="d-flex">
						{#if refStr}Reference #: {refStr}{/if}
					</div>
					<div class="d-flex">
						{#if ShowConfirm}
							<button class="btn btn-primary" type="button" on:click={Hide}>
								{#if showTitle}
									Confirm
								{:else}
									Okay
								{/if}
							</button>
						{/if}
					</div>
				</div>
			{/if}
		</div>
	</div>
</div>

<style>
	.modal-body-centered {
		text-align: center;
	}
	.modal {
		z-index: 1050; /* Ensure the modal is always on top */
	}
	.modal-backdrop {
		z-index: 1040; /* Ensure the backdrop is below the modal */
	}
</style>
